import { Component, OnInit, EventEmitter, Output } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal/bs-modal-ref.service';
import { CajaService } from '../../../services/caja.service';
import { SessionService } from '../../../services/session.service';
import { Caja } from '../../../models/caja';
import { AsignacionCaja } from '../../../models/asignacion-caja';
import * as moment from 'moment';
import { AsignacionCajaService } from '../../../services/asignacion-caja.service';
import { ArqueoCaja } from '../../../models/arqueo_caja';
import { SweetMessage } from '../../../config/sweet-message';
import { Validation } from '../../../config/validation';

@Component({
  selector: 'app-apertura-caja-modal',
  templateUrl: './apertura-caja-modal.component.html',
  styleUrls: ['./apertura-caja-modal.component.css'],
  providers: [
	CajaService,
	SessionService,
	AsignacionCajaService
  ]
})
export class AperturaCajaModalComponent implements OnInit {
	@Output() caja_id: number;
  	@Output() action = new EventEmitter();
	public cajas: Array<Caja>;
	public caja: Caja;
	public valor_inicial: String;
	public asignacion: AsignacionCaja;
	public fecha_emision;
	public arqueo: ArqueoCaja;
	public msgSweet: SweetMessage;
	public vl: Validation;
	public loading: boolean = false;

  constructor(
		public bsModalRef: BsModalRef,
		public cajaService: CajaService,
		public ss: SessionService,
		public asignacionService: AsignacionCajaService,
	) { 
		this.cajas = [];
		this.caja = new Caja();
		this.valor_inicial = "";
		this.asignacion = new AsignacionCaja();
		this.fecha_emision = moment(this.fecha_emision);
		this.arqueo = new ArqueoCaja();
		this.msgSweet = new SweetMessage();
		this.vl = new Validation();
	}

	ngOnInit() {
		this.loading = true;

		this.getCajas().then(
			res => this.loading = false,
			err => this.loading = false,
		);
	}

  	getCajas(){
		return new Promise((resolve, reject ) => {
			this.cajaService.getAll("?embed=sucursal&sucursal_id=" + this.ss.getData('sucursal_id')).subscribe(
				res => {                
					this.cajas = res.data;
					resolve();
				},
				err => {                
					this.cajas = [];
					reject(err);
				}
			);
		});        
	}

	onChangeCaja(){
		this.valor_inicial = ""
		let qs = "?caja_id=" + this.caja.id;

		this.loading = true;

		this.asignacionService.getCaja(qs).subscribe(
            res => {
				if (res['tipo'] == 'A') {
                    this.msgSweet.showMessage('error-message', "La caja seleccionada se encuentra aperturada");
					this.caja = new Caja();
				}
				this.loading = false;
            },
            err => {
				this.loading = false;
            }
        );
    }

	Response(id){
		this.caja_id = id;
		this.bsModalRef.hide();

		this.setApertura();
		this.onChangeCaja();

		this.loading = true;
		this.asignacionService.save(this.asignacion).subscribe(
			res => {
				this.loading = false;
				this.action.emit(this.caja_id);
			},
			err => {
				this.loading = false;
			}
		);
	}

	isValidForm(){
        if( !this.caja.id ){
            return false;
		}

		if( this.valor_inicial.toString().trim().length < 1 || parseFloat(this.valor_inicial.toString()) == 0 ){
            return false;
		}
		
        return true;
    }

	setApertura(){
		this.asignacion.caja_id = this.caja.id;
		this.asignacion.empresa_id = this.ss.getData("empresa_id");
		this.asignacion.fecha = moment(this.fecha_emision).format("YYYY-MM-DD");
		this.asignacion.sucursal_id = this.ss.getData("sucursal_id");
		this.asignacion.tipo = 'A';
		this.asignacion.usuario_id = this.ss.getData("usuario_id");
		let arqueo = new ArqueoCaja();
		arqueo.definicion_id = "1"; //VI-VALOR INICIAL
		arqueo.empresa_id = this.ss.getData("empresa_id");
		arqueo.fecha = moment(this.fecha_emision).format("YYYY-MM-DD H:mm:ss");
		arqueo.sucursal_id = this.ss.getData("sucursal_id");
		arqueo.tipo = "A";
		arqueo.usuario_id = this.ss.getData("usuario_id");
		arqueo.valor = parseFloat(this.valor_inicial.toString());
		this.asignacion.arqueos.push(arqueo);
	}

	clickKeyboard(key){
        if( key == "C" ){
            this.valor_inicial = this.valor_inicial.toString().slice(0,-1)
        }else{
            this.valor_inicial = this.valor_inicial + key;
        }
    }

}



// WEBPACK FOOTER //
// /var/www/nodejs/nextstore/src/app/components/modals/apertura-caja-modal/apertura-caja-modal.component.ts